export const idlFactory = ({ IDL }) => {
  const PublicKey = IDL.Text;
  const Ciphertext = IDL.Text;
  const GetCiphertextError = IDL.Variant({
    'notSynced' : IDL.Null,
    'notFound' : IDL.Null,
  });
  const Result = IDL.Variant({ 'ok' : Ciphertext, 'err' : GetCiphertextError });
  const DeviceAlias = IDL.Text;
  const EncryptedNote = IDL.Record({
    'id' : IDL.Nat,
    'encrypted_text' : IDL.Text,
  });
  const anon_class_23_1 = IDL.Service({
    'add_note' : IDL.Func([IDL.Text], [], []),
    'delete_note' : IDL.Func([IDL.Int], [], []),
    'get_ciphertext' : IDL.Func([PublicKey], [Result], []),
    'get_devices' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(DeviceAlias, PublicKey))],
        [],
      ),
    'get_notes' : IDL.Func([], [IDL.Vec(EncryptedNote)], []),
    'get_unsynced_pubkeys' : IDL.Func([], [IDL.Vec(PublicKey)], []),
    'is_seeded' : IDL.Func([], [IDL.Bool], []),
    'register_device' : IDL.Func([DeviceAlias, PublicKey], [IDL.Bool], []),
    'remove_device' : IDL.Func([DeviceAlias], [], ['oneway']),
    'seed' : IDL.Func([PublicKey, Ciphertext], [], ['oneway']),
    'submit_ciphertexts' : IDL.Func(
        [IDL.Vec(IDL.Tuple(PublicKey, Ciphertext))],
        [],
        ['oneway'],
      ),
    'update_note' : IDL.Func([EncryptedNote], [], []),
    'whoami' : IDL.Func([], [IDL.Text], []),
  });
  return anon_class_23_1;
};
export const init = ({ IDL }) => { return []; };
